export const ROUTES = {
  login: "/login",
  user: "/user",
  profile: "/profile",
  product: "/product",
  productHistory: "/productHistory",
  client: "/client",
  clientHistory: "/clientHistory",
  expense: "/expense",
  budget: "/budget",
  transaction: "/transaction",
};
